import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, WHATSAPP } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const WhatsappSettingList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.string, width: 90, show: false },
			{
				Header: 'templateOTOId',
				accessor: 'templateOTOId',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{
				Header: 'whatsappUserId',
				accessor: 'whatsappUserId',
				filterType: FilterType.string,
				width: 90,
				show: false
			},
			{ Header: 'brandID', accessor: 'brandID', filterType: FilterType.string, width: 90, show: false },
			{ Header: 'connectionID', accessor: 'connectionID', filterType: FilterType.string, width: 90, show: false },
			{
				Header: 'messageType',
				accessor: 'otoMessageType',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'settingName',
				accessor: 'settingName',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'connectionName',
				accessor: 'connectionName',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			},
			{
				Header: 'storeName',
				accessor: 'storeName',
				filterType: FilterType.multiSelection,
				width: 100,
				renderCell: ListComponents.BRAND_LOGO,
				roleName: 'BrandingModule'
			},
			{ Header: 'language', accessor: 'language', filterType: FilterType.multiSelection },
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.EMAIL_TEMP_STATUS,
				width: 100,
				renderCell: ListComponents.STATUS
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.WHATSAPP_SETTINGS}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={WHATSAPP.GET_WHATSAPP_SETTING_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="whatsappSettings"
			/>
		</TabTableContainer>
	);
};

export default WhatsappSettingList;
